export const GET_VISUALIZATION_DATA = 'visualizationData/getVisualizationData'